import { render, staticRenderFns } from "./AssignPermissionToRole.vue?vue&type=template&id=28a084c4&scoped=true&"
import script from "./AssignPermissionToRole.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionToRole.vue?vue&type=script&lang=js&"
import style0 from "./AssignPermissionToRole.vue?vue&type=style&index=0&id=28a084c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a084c4",
  null
  
)

export default component.exports